import { render, staticRenderFns } from "./BaseAddresses.vue?vue&type=template&id=7ca4d81a&"
import script from "./BaseAddresses.vue?vue&type=script&lang=js&"
export * from "./BaseAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports